const BaseResponsesObject = {
    sight1(){
        return {
            q01: -1,
            q02: -1,
            q03: -1,
            q04: -1,
            q05: -1,
            q06: -1,
            q07: -1,
            q08: -1,
            q09: -1,
            q10: -1,
            q11: -1,
            q12: -1,
            q13: -1,
            q14: -1,
            q15: -1,
            q16: -1,
            q17: -1,
            q18: -1,
            q19: -1,
            q20: -1
        }
    },
    sight2(){
        return {
            q01: -1,
            q02: -1,
            q03: -1,
            q04: -1,
            q05: -1,
            q06: -1,
            q07: -1,
            q08: -1,
            q09: -1,
            q10: -1,
            q11: -1,
            q12: -1,
            q13: -1,
            q14: -1,
            q15: -1,
            q16: -1,
            q17: -1,
            q18: -1,
            q19: -1,
            q20: -1,
            q21: -1,
            q22: -1,
            q23: -1,
            q24: -1,
            q25: -1,
            q26: -1,
            q27: -1,
            q28: -1,
            q29: -1,
            q30: -1,
            q31: -1,
            q32: -1,
            q33: -1
        }
    }
}
export default BaseResponsesObject